/* businesses */
export const LIST_SUPPORT_MATERIALS = "LIST_SUPPORT_MATERIALS"
export const LIST_SUPPORT_MATERIALS_SUCCESS = "LIST_SUPPORT_MATERIALS_SUCCESS"
export const LIST_SUPPORT_MATERIALS_CLEAN = "LIST_SUPPORT_MATERIALS_CLEAN"
export const LIST_SUPPORT_MATERIALS_ERROR = "LIST_SUPPORT_MATERIALS_ERROR"
